import type { Location } from 'react-router-dom';

import {
  CUSTOMER_AREA_ORDER_PATH_BY_COUNTRY,
  CUSTOMER_AREA_POTENTIAL_PATH_BY_COUNTRY,
} from '@wecasa/common/src/constants/country';
import { getCurrentCountry } from '@wecasa/common/src/utils/country';

import {
  type GetRecurringChildcareCalendlyUrlFunc,
  getInstantTaxCreditFunnelUrl,
  getRecurringChildcareCalendlyUrl,
} from '@wecasa/customer/src/utils/navigation';

import { route } from '../steps/steps';
import type { LocationState } from '../types';

export const getPreviousPath = (location?: Location<LocationState>) =>
  location?.state?.from ? location.state.from : route('root');

export const getNextPath = (location?: Location<LocationState>) => location?.state?.to || undefined;

export const getPreviousSearch = (location?: Location<LocationState>) => location?.state?.fromSearch || '';

export const goToInstantTaxCreditFunnel = (potentialPublicId: string) => {
  window.location.replace(
    getInstantTaxCreditFunnelUrl({
      siteUrl: window.wecasa.siteUrl,
      searchParams: { potential_public_id: potentialPublicId },
    }),
  );
};

export const goToPotentialInfoAfterModification = (potentialPublicId: string) => {
  const { siteUrl, locale } = window.wecasa;

  window.location.replace(
    `${siteUrl}${locale}/${CUSTOMER_AREA_POTENTIAL_PATH_BY_COUNTRY[getCurrentCountry()]}${potentialPublicId}?track_booking_updated=true`,
  );
};

export const goToOrderInfoAfterModification = (orderPublicId: string) => {
  const { siteUrl, locale } = window.wecasa;

  window.location.replace(
    `${siteUrl}${locale}/${CUSTOMER_AREA_ORDER_PATH_BY_COUNTRY[getCurrentCountry()]}${orderPublicId}?track_booking_updated=true`,
  );
};

export const goToRecurringChildcareCalendly = (...args: Parameters<GetRecurringChildcareCalendlyUrlFunc>) =>
  window.open(getRecurringChildcareCalendlyUrl(...args), '_blank');

export const goToWecasaHomePage = () => window.location.replace(window.wecasa.siteUrl || '');
